import { all } from 'redux-saga/effects';

import authSaga from './auth/saga';
import layoutSaga from './layout/saga';

import AreaSaga from './areas/saga';
import LandmarkSaga from './landmark/saga';
import CustomerSaga from './customer/saga';
import ProductSaga from './product/saga';
import AllotmentSaga from './allotment/saga';
import ExpensecategorySaga from './expenseCategory/saga';
import DesignationSaga from './designation/saga';
import SalesSaga from './sales/saga';
import EmployeeSaga from './employee/saga';
import branchSaga  from './branch/saga';
import ExpensesSaga from './expenses/saga';
import OutstandingSaga from './outstanding/saga';
import SettingsSaga from './settings/saga';
import DraftSaga from './draft/saga';
import CollectionsSaga from './collections/saga';
import ReturnOrderSaga from './returnOrder/saga';
import tallySaga from './tally/saga';

export default function* rootSaga() {
    yield all([
        authSaga(),
        layoutSaga(),
        AreaSaga(),
        LandmarkSaga(),
        CustomerSaga(),
        ProductSaga(),
        AllotmentSaga(),
        ExpensecategorySaga(),
        DesignationSaga(),
        SalesSaga(),
        EmployeeSaga(),
        branchSaga(),
        ExpensesSaga(),
        OutstandingSaga(),
        SettingsSaga(),
        DraftSaga(),
        CollectionsSaga(),
        ReturnOrderSaga(),
        tallySaga(),
    ]);
}
